var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-autocomplete',_vm._g(_vm._b({attrs:{"id":"value","items":_vm.results,"item-text":_vm.itemText,"return-object":""},on:{"change":(payload) => _vm.$emit('select', payload)},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},'custom-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }